export function getAnimationData(anim) {

  let dir, animation, pageAssets
  const path = window.theme_path.replace('gb', '') + '/images/header-animation-elements/'

  switch (anim) {
  	case 'animation_1':
    	dir = 'animation_1/'
      pageAssets = {
        hero: path + dir + 'US_chicken_pasta.png',
        background: path + dir + 'Banner_Homepage_US-Chicken_Pasta.jpg'
      }
  		animation = [
        {img: path + dir + 'pepper.png', x: 68 , y: 535, s: 'right'},
  			{img: path + dir + 'dp1.png', x: 31 , y: 452, s: 'left'},
        {img: path + dir + 'tomato2.png', x: 64 , y: 410, s: 'right'},
  			{img: path + dir + 'dp2.png', x: 13.5 , y: 360, s: 'left'},
        {img: path + dir + 'dp1.png', x: 32 , y: 395, r: 70, s: 'left'},
  			{img: path + dir + 'basil2.png', x: 73.5 , y: 434, s: 'right'},
        {img: path + dir + 'dp1.png', x: 13.5, y: 295, r: -7, s: 'left'},
        {img: path + dir + 'basil1.png', x: 28 , y: 292, s: 'left'},
        {img: path + dir + 'mushroom.png', x:82 , y: 200, s: 'right'},
  			{img: path + dir + 'onion1.png', x: 25 , y: 495, s: 'left'},
  			{img: path + dir + 'dp2.png', x: 62 , y: 283, s: 'right'},
        {img: path + dir + 'basil2.png', x: 33 , y: 530, r: -60, s: 'left'},
  			{img: path + dir + 'tomato1.png', x: 24 , y: 400, s: 'left'},
  			{img: path + dir + 'dp2.png', x: 79 , y: 450, s: 'right'},
  			{img: path + dir + 'carrot.png', x: 13 , y: 135, r: 60, s: 'left'},
  			{img: path + dir + 'dp1.png', x: 69 , y: 343, s: 'right'},
  			{img: path + dir + 'dp2.png', x: 37 , y: 454, s: 'left'},
  			{img: path + dir + 'celery.png', x: 66.5 , y: 170, r: -15, s: 'right'},
  			{img: path + dir + 'mushroom.png', x:18 , y: 540, r: -125, s: 'left'},
        {img: path + dir + 'dp1.png', x: 66.5 , y: 500, r: -40, s: 'right'},
        {img: path + dir + 'dp1.png', x: 37 , y: 495, r: -40, s: 'left'},
        {img: path + dir + 'basil2.png', x: 80 , y: 500, r: 170, s: 'right'},
      ]
  	break;
  	case 'animation_2':
      dir = 'animation_2/'
      pageAssets = {
        hero: path + dir + 'product-chicken-veg-pie.png',
        background: path + dir + 'Banner_Homepage_UK-Chicken_Veg_Pie.jpg'
      }
      animation = [
        {img: path + dir + 'peas.png', x: 18 , y: 310, s: 'left'},
        {img: path + dir + 'peas2.png', x: 64 , y: 300, s: 'right'},
        {img: path + dir + 'peas-single.png', x: 27.8 , y: 442, s: 'left'},
        {img: path + dir + 'peas-single.png', x: 66 , y: 278, s: 'right'},
        {img: path + dir + 'carrot-medium-left.png', x: 12 , y: 385, s: 'left'},
        {img: path + dir + 'carrot-medium-right.png', x: 67 , y: 570, s: 'right'},
        {img: path + dir + 'thyme.png', x: 62 , y: 190, s: 'right'},
        {img: path + dir + 'peas-single.png', x: 13 , y: 190, s: 'left'},
        {img: path + dir + 'thyme2.png', x: 10 , y: 470, s: 'left'},
        {img: path + dir + 'carrot-large-right.png', x: 80 , y: 440, s: 'right'},
        {img: path + dir + 'onion-right.png', x: 70.5 , y: 442, s: 'right'},
        {img: path + dir + 'carrot-small-left.png', x: 10 , y: 292, s: 'left'},
        {img: path + dir + 'peas-single.png', x: 11.8 , y: 140, r: -140, s: 'left'},
        {img: path + dir + 'potato-right.png', x: 78 , y: 225, s: 'right'},
        {img: path + dir + 'onion-left.png', x: 24 , y: 490, s: 'left'},
        {img: path + dir + 'carrot-large-left.png', x: 24.5 , y: 182, s: 'left'},
        {img: path + dir + 'potato-left.png', x: 24 , y: 269, s: 'left'},
      ]
  	break;
  	case 'animation_3':
      dir = 'animation_3/'
      pageAssets = {
        hero: path + dir + 'US_lentil-beef.png',
        background: path + dir + 'Banner_Homepage_US-Lentil_Beef_Stew.jpg'
      }
      animation = [
        {img: path + dir + 'lentils-1-left.png', x: 32.5 , y: 470, s: 'left'},
        {img: path + dir + 'lentils-1-right.png', x: 57 , y: 430, s: 'right'},
        {img: path + dir + 'lentils-2-left.png', x: 24 , y: 335, s: 'left'},
        {img: path + dir + 'lentils-2-right.png', x: 89 , y: 180, s: 'right'},
        {img: path + dir + 'mushroom-1-left.png', x: 31 , y: 375, s: 'left'},
        {img: path + dir + 'mushroom-1-right.png', x: 67 , y: 180, s: 'right'},
        {img: path + dir + 'mushroom-2-right.png', x: 67.5 , y: 373, s: 'right'},
        {img: path + dir + 'mushroom-3-right.png', x: 65 , y: 295, s: 'right'},
        {img: path + dir + 'carrot-right.png', x: 61 , y: 290, s: 'right'},
        {img: path + dir + 'carrot-slice-right.png', x: 76 , y: 517, s: 'right'},
        {img: path + dir + 'carrot-slice-1-left.png', x: 27 , y: 560, s: 'left'},
        {img: path + dir + 'carrot-slice-2-left.png', x: 29 , y: 270, s: 'left'},
        {img: path + dir + 'carrot-slice-3-left.png', x: 14 , y: 210, s: 'left'},
        {img: path + dir + 'beans1.png', x: 1 , y: 198, s: 'left'},
        {img: path + dir + 'beans-2-left.png', x: 11 , y: 478, s: 'left'},
        {img: path + dir + 'beans-right.png', x: 68 , y: 173, s: 'right'},
        {img: path + dir + 'potato-right.png', x: 87 , y: 290, s: 'right'},
        {img: path + dir + 'potato-1-left.png', x: 19 , y: 210, s: 'left'},
        {img: path + dir + 'potato-2-left.png', x: 8 , y: 362, s: 'left'},
      ]
  	break;
    case 'animation_4':
      dir = 'animation_4/'
      pageAssets = {
        hero: path + dir + 'US_pasta-bolognese.png',
        background: path + dir + 'Banner_Homepage_US-Pasta_Bolognese.jpg'
      }
      animation = [
        {img: path + dir + 'tomato2.png', x: 62 , y: 410, s: 'right'},
        {img: path + dir + 'dp2.png', x: 64 , y: 313, s: 'right'},
        {img: path + dir + 'garlic-1-right.png', x: 68.5 , y: 470, s: 'right'},
        {img: path + dir + 'basil1-right.png', x: 64 , y: 537, s: 'right'},
        {img: path + dir + 'papper-right.png', x: 74 , y: 420, s: 'right'},
        {img: path + dir + 'dp1-right.png', x: 72 , y: 345, s: 'right'},
        {img: path + dir + 'tomato1-right.png', x: 70 , y: 220, s: 'right'},
        {img: path + dir + 'basil-2-right.png', x: 81 , y: 257, s: 'right'},
        {img: path + dir + 'basil3-right.png', x: 78 , y: 295, s: 'right'},
        {img: path + dir + 'dp2.png', x: 87 , y: 207, s: 'right'},
        {img: path + dir + 'dp4.png', x: 88 , y: 455, s: 'right'},
        {img: path + dir + 'dp5.png', x: 83 , y: 567, s: 'right'},
        {img: path + dir + 'dp2.png', x: 34 , y: 497, s: 'left'},
        {img: path + dir + 'basil3-left.png', x: 27 , y: 451, s: 'left'},
        {img: path + dir + 'garlic.png', x: 26 , y: 562, s: 'left'},
        {img: path + dir + 'tomato2.png', x: 19 , y: 477, s: 'left'},
        {img: path + dir + 'dp5.png', x: 30 , y: 377, s: 'left'},
        {img: path + dir + 'tomato1.png', x: 23 , y: 378, s: 'left'},
        {img: path + dir + 'garlic-left.png', x: 27 , y: 287, s: 'left'},
        {img: path + dir + 'basil-2-right.png', x: 23 , y: 206, s: 'left'},
        {img: path + dir + 'papper-left.png', x: 13 , y: 237, s: 'left'},
        {img: path + dir + 'dp2.png', x: 8 , y: 357, s: 'left'},
        {img: path + dir + 'dp3.png', x: 11 , y: 467, s: 'left'},
      ]
    break;
    case 'animation_5':
      dir = 'animation_5/'
      pageAssets = {
        hero: path + dir + 'UK_pasta-bolognese.png',
        background: path + dir + 'Banner_Homepage_UK-Pasta_Bolognese.jpg'
      }
      animation = [
        {img: path + dir + 'basil2-right.png', x: 64 , y: 580, s: 'right'},
        {img: path + dir + 'garlic-1-right.png', x: 66 , y: 480, s: 'right'},
        {img: path + dir + 'carrot-slice-1-left.png', x: 63.5 , y: 393, s: 'right'},
        {img: path + dir + 'Pasta-2-right.png', x: 70 , y: 557, s: 'right'},
        {img: path + dir + 'Pasta.png', x: 71 , y: 432, s: 'right'},
        {img: path + dir + 'BS-cube-10.png', x: 77 , y: 561, s: 'right'},
        {img: path + dir + 'BS-cube-13.png', x: 75 , y: 457, s: 'right'},
        {img: path + dir + 'basil2.png', x: 71 , y: 298, s: 'right'},
        {img: path + dir + 'Pasta-7.png', x: 83 , y: 547, s: 'right'},
        {img: path + dir + 'tomato2.png', x: 82 , y: 415, s: 'right'},
        {img: path + dir + 'Pasta-9-right.png', x: 78 , y: 346, s: 'right'},
        {img: path + dir + 'carrot-slice-1-left.png', x: 86 , y: 307, s: 'right'},
        {img: path + dir + 'tomato1-right.png', x: 81 , y: 188, s: 'right'},
        {img: path + dir + 'Pasta-5.png', x: 31 , y: 558, s: 'left'},
        {img: path + dir + 'garlic.png', x: 23 , y: 578, s: 'left'},
        {img: path + dir + 'basil1.png', x: 21 , y: 458, s: 'left'},
        {img: path + dir + 'tomato2.png', x: 28 , y: 378, s: 'left'},
        {img: path + dir + 'garlic-left.png', x: 24 , y: 308, s: 'left'},
        {img: path + dir + 'carrot-slice-1-left.png', x: 22 , y: 219, s: 'left'},
        {img: path + dir + 'tomato1.png', x: 18 , y: 370, s: 'left'},
        {img: path + dir + 'Pasta-2.png', x: 12 , y: 580, s: 'left'},
        {img: path + dir + 'Pasta.png', x: 15 , y: 500, s: 'left'},
        {img: path + dir + 'carrot-slice-1-left.png', x: 8 , y: 380, s: 'left'},
        {img: path + dir + 'Pasta-8.png', x: 15 , y: 300, s: 'left'},
        {img: path + dir + 'Pasta-3.png', x: 6 , y: 310, s: 'left'},
        {img: path + dir + 'BS-cube-11.png', x: 9 , y: 200, s: 'left'},
      ]
    break;
    case 'animation_6':
      dir = 'animation_6/'
      pageAssets = {
        hero: path + dir + 'UK_chicken-risotto.png',
        background: path + dir + 'Banner_Homepage_UK-Chicken_Veg_Risotto.jpg'
      }
      animation = [
        {img: path + dir + 'thyme-1-right.png', x: 65 , y: 540, s: 'right'},
        {img: path + dir + 'BS-cube-1-right.png', x: 71 , y: 460, s: 'right'},
        {img: path + dir + 'rice3-right.png', x: 60.5 , y: 284, s: 'right'},
        {img: path + dir + 'BS-cube-2-right.png', x: 78 , y: 357, s: 'right'},
        {img: path + dir + 'thyme.png', x: 67 , y: 163, s: 'right'},
        {img: path + dir + 'rice2-right.png', x: 80 , y: 487, s: 'right'},
        {img: path + dir + 'sweet-potato.png', x: 64 , y: 353, s: 'right'},
        {img: path + dir + 'rice1-right.png', x: 81 , y: 217, s: 'right'},
        {img: path + dir + 'BS-cube-3-right.png', x: 89 , y: 517, s: 'right'},
        {img: path + dir + 'rice1-left.png', x: 32 , y: 417, s: 'left'},
        {img: path + dir + 'BS-cube-2-right.png', x: 26 , y: 378, s: 'left'},
        {img: path + dir + 'BS-cube-9-left.png', x: 26 , y: 307, s: 'left'},
        {img: path + dir + 'thyme-1-left.png', x: 20 , y: 441, s: 'left'},
        {img: path + dir + 'thyme-2-left.png', x: 17 , y: 298, s: 'left'},
        {img: path + dir + 'Rice2-left.png', x: 24 , y: 207, s: 'left'},
        {img: path + dir + 'sweet-potato-left.png', x: 7 , y: 257, s: 'left'},
        {img: path + dir + 'BS-left.png', x: 12 , y: 452, s: 'left'},
      ]
    break;
  }

  return { animation, pageAssets }

}



// WEBPACK FOOTER //
// ./src/animations/animations.js